(function(window, angular, undefined) {
    angular.module('formApp')
        .controller('errorCtrl',  ['$scope', '$q', 'FormService', 'updateHeader', '$state', '$log', 'formData', 'scrollToPoint', '$timeout', '$window', function($scope, $q, formService, updateHeader, $state, $log, formData, scrollToPoint, $timeout, $window) {

            console.log('error ctrl');
            $scope.errorPageType = $state.params.message;
            $scope.errorPageTypeVar = $state.params.etype;
            $scope.errorPageTypeRid = $state.params.rid;
            $scope.errorPageTypeSid = $state.params.sid;


            $scope.startNew = function() {
                $state.go('step-1', {forward: true});
            };

            $scope.goBack = function() {
                $window.history.back();
            };
          
            var trustboxRef = document.getElementById('trustbox');
            if(trustboxRef && window.Trustpilot){
                window.Trustpilot.loadFromElement(trustboxRef);
            }
        }]);
})(window, window.angular);